import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'getGoogleReviewAutoReplySettings';

export const useGetGoogleReviewAutoReplySettings = ({
	enabled = true,
	impersonationContext,
	meta,
	refetchOnWindowFocus = false,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
	refetchOnWindowFocus?: boolean;
} = {}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IGoogleReviewAutoReplySettings>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'googleBusiness/reviewAutoReplySettings',
				}),
				'GET'
			);
		},
		enabled,
		meta,
		queryKey: [BASE_QUERY_KEY, impersonationContext],
		refetchOnWindowFocus,
	});
};

export const setGoogleReviewAutoReplySettingsQueryData = (
	settings: Api.IGoogleReviewAutoReplySettings,
	{ impersonationContext }: { impersonationContext?: Api.IImpersonationContext } = {}
) => {
	reactQueryClient.setQueryData([BASE_QUERY_KEY, impersonationContext], settings);
};
